import { v4 as uuidv4 } from "uuid";
// Mirrors System1.Core.Entities.ActionItemStatus
export var ActionItemStatus;
(function (ActionItemStatus) {
    ActionItemStatus[ActionItemStatus["Open"] = 1] = "Open";
    ActionItemStatus[ActionItemStatus["Completed"] = 2] = "Completed";
    // No longer needed, so it won't be done
    ActionItemStatus[ActionItemStatus["Closed"] = 3] = "Closed";
})(ActionItemStatus || (ActionItemStatus = {}));
export class ActionItemModel {
    constructor() {
        this.id = uuidv4();
        this.clientId = "";
        this.clientName = "";
        this.updateId = null;
        this.teamId = null;
        this.teamName = "";
        this.description = "";
        this.assigneeUserId = "";
        this.assigneeName = "";
        this.assigneeImageURL = "";
        this.dueDate = null;
        this.status = ActionItemStatus.Open;
        this.completedOn = null;
        this.completedBy = null;
        this.closedOn = null;
        this.closedBy = null;
        this.closedByName = "";
        this.createdOn = null;
        this.createdBy = null;
        this.createdByName = "";
    }
}
export default class ActionItem extends ActionItemModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
